<template>
  <div>
    <el-table :data="tableData" stripe size="mini" max-height="400">
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="templateFileDesc"
        :label="$l('export_table_head_ExportTemplate') || '导出模板'"
        min-width="200"
      ></el-table-column>
      <el-table-column :label="$l('table_head_operation') || '操作'" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="exportQuotation(scope.row)">{{$l('export_table_head_Export') || '导出'}}</el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
  </div>
</template>
<script>
// import { quotationExportTemplateListApi } from '@api/personal/myQuotation'
export default {
  data () {
    return {
      tableData: []
    }
  },
  methods: {
    // 加载表单数据
    loadData () {
      this.$api.myQuotationExportTemplateListApi('ABS').then(res => {
        this.tableData = res.body.data
      })
    },
    // 导出
    exportQuotation (row) {
      // 通知父组件导出
      this.$emit('export', row)
    }
  }
}
</script>
